<div class="container-fluid payment-history-root">
  <div class="d-flex justify-content-end meter-type-tabs">
    <div class="meter-type-tab" routerLink="/payment-history">
      <span>{{ 'PAYMENT_HISTORY.TAB_PAYMENTS' | translate }}</span>
    </div>
    <div class="meter-type-tab active">
      <span>{{ 'PAYMENT_HISTORY.TAB_SETTLEMENTS' | translate }}</span>
    </div>
  </div>

  <div class="stats-root">
    <div id="settlement_card_total-settlements" class="stats-item">
      <div>{{ 'SETTLEMENTS.TOTAL_SETTLEMENTS' | translate }}</div>
      <div>{{ summary.totalSettlements | number }}</div>
    </div>
    <div id="settlement_card_transactions-settled" class="stats-item">
      <div>{{ 'SETTLEMENTS.TRANSACTIONS_SETTLED' | translate }}</div>
      <div>{{ summary.transactionsSettled | number }}</div>
    </div>
    <div id="settlement_card_successful" class="stats-item">
      <div>{{ 'COMMON.SETTLEMENT_STATUS.SUCCESSFUL' | translate }}</div>
      <div>{{ summary.successful | number }}</div>
    </div>
    <div id="settlement_card_pending" class="stats-item">
      <div>{{ 'COMMON.SETTLEMENT_STATUS.PENDING' | translate }}</div>
      <div>{{ summary.pending | number }}</div>
    </div>
    <div id="settlement_card_failed" class="stats-item">
      <div>{{ 'COMMON.SETTLEMENT_STATUS.FAILED' | translate }}</div>
      <div>{{ summary.failed | number }}</div>
    </div>
  </div>

  <div class="table-root">
    <div class="table-root-child">
      <!-- table-action-wrapper carries the global .datepicker-icon rule that pads the input
           for its absolutely positioned label. -->
      <div class="filter table-action-wrapper">
        <div class="filter-list">
          <div id="settlement_date-from" class="datepicker-container">
            <label for="dateFrom"> {{'COMMON.FROM' | translate}}: </label>
            <input type="date" id="dateFrom" name="dateFrom" class="date-input"
              [ngClass]="dateFrom > dateTo ? 'btn datepicker-icon-error' : 'btn datepicker-icon'"
              [(ngModel)]="dateFrom" (change)="createFilterCards()" />
          </div>
          <div id="settlement_date-to" class="datepicker-container">
            <label for="dateTo" class="right-label"> {{'COMMON.TO' | translate}}: </label>
            <input type="date" id="dateTo" name="dateTo" class="date-input"
              [ngClass]="dateFrom > dateTo ? 'btn datepicker-icon-error' : 'btn datepicker-icon'"
              [(ngModel)]="dateTo" (change)="createFilterCards()" />
          </div>
          <app-multi-select-dropdown *ngIf="organizations.length > 0" id="settlement_vendor_filter"
            class="multiselect" [clicked]="clicked" [items]="organizations" [label]="'SURVEYS.MAP_VENDOR'"
            [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectVendor()">
          </app-multi-select-dropdown>
          <app-multi-select-dropdown id="settlement_status_filter" class="multiselect" [clicked]="clicked"
            [items]="settlementStatusItems" [label]="'COMMON.SETTLEMENT_STATUS.SINGLE'" [showMore]="false"
            [requireApply]="true" (shareIndividualCheckedList)="selectStatus()">
          </app-multi-select-dropdown>
        </div>
        <div *ngIf="selectedFilters.length > 0">
          <app-filter-checklist [filters]="selectedFilters" [useApply]="true"
            (resetFilterEmitter)="resetFilter()" (removeFilterEmitter)="removeFilter($event)"
            (applyFilterEmitter)="applyFilter()">
          </app-filter-checklist>
        </div>
      </div>

      <div class="table">
        <div *ngIf="settlements">
          <table class="table border-bottom">
            <thead class="table-light">
              <tr>
                <th id="settlement_table_header_timestamp">{{'PAYMENT_HISTORY.DATE_TIMESTAMP' | translate}}</th>
                <th id="settlement_table_header_settlement-id">{{'SETTLEMENTS.SETTLEMENT_ID' | translate}}</th>
                <th id="settlement_table_header_vendor">{{'SURVEYS.MAP_VENDOR' | translate}}</th>
                <th id="settlement_table_header_transactions">{{'SETTLEMENTS.TRANSACTIONS_SETTLED' | translate}}</th>
                <th id="settlement_table_header_amount">{{'COMMON.AMOUNT' | translate}}</th>
                <th id="settlement_table_header_status">{{'COMMON.SETTLEMENT_STATUS.SINGLE' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr [id]="'settlement_table_row-' + (i + 1)" *ngFor="let item of settlements; let i = index">
                <td [id]="'settlement_table_timestamp-' + (i + 1)" [routerLink]="['details', item.id]"
                  (click)="setFilterStorage()">{{ item.settlementDate | utcDate }}</td>
                <td [id]="'settlement_table_settlement-id-' + (i + 1)" [routerLink]="['details', item.id]"
                  (click)="setFilterStorage()">{{ item.paymentHubSettlementId | hasValue }}</td>
                <td [id]="'settlement_table_vendor-' + (i + 1)" [routerLink]="['details', item.id]"
                  (click)="setFilterStorage()">{{ item.vendorName | hasValue }}</td>
                <td [id]="'settlement_table_transactions-' + (i + 1)" [routerLink]="['details', item.id]"
                  (click)="setFilterStorage()">{{ item.transactionsSettled | number }}</td>
                <td [id]="'settlement_table_amount-' + (i + 1)" [routerLink]="['details', item.id]"
                  (click)="setFilterStorage()">{{ item.amount | number:'1.2-2' }}</td>
                <td [id]="'settlement_table_status-' + (i + 1)" [routerLink]="['details', item.id]"
                  (click)="setFilterStorage()">
                  <div *ngIf="item.status" class="payment-status" [ngClass]="getStatusClass(item.status)">
                    {{ getStatusKey(item.status) | translate }}
                  </div>
                  <div *ngIf="!item.status">
                    ----
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <app-paging *ngIf="count > 0" [pageSize]="pageSize" [count]="count" [currentPage]="currentPage"
              [useDirect]="true" (pageChange)="pageChange($event)"></app-paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
